import React from "react";
import { Button } from "@mui/material";

const ButtonComponent = ({ title, onClick, type }) => {
  return (
    <Button
      variant="contained"
      style={{
        margin: "30px auto",
        borderRadius: "27px",
        backgroundColor: "#538dd6",
        fontFamily: "PoppinsMedium",
      }}
      size="large"
      className="d-flex"
      onClick={onClick}
      type={type}
    >
      {title}
    </Button>
  );
};

export default ButtonComponent;
